import React from "react";
import withLocalization from "../../../../hoc/with-localization";
import InputGroup from "../input-group/input-group";
import inpSetts from "../../../../settings/params-settings";
import QTcAlgtypeEditor from "../QTc-algtype-editor";

const CmpxEditor = props => {
    const {
        loc,
        data: { QRS_ms, PQ_ms, PDur_ms, QTmax_ms, QTcAlg, QTcAvailableAlgs, angle_QRS, angle_P, angle_T, RR_ms, Q_next_ms },
        onChanged
    } = props;
    const ms = loc("units.ms"),
        gr = "°";

    const PQmin = inpSetts.PQ.min;
    const PQmax = RR_ms !== undefined && RR_ms !== null ? RR_ms : inpSetts.PQ.max; // Максимальный порог не установлен, он должен определяться именно по RR

    const QRSmin = inpSetts.QRS.min;
    const QRSmax = inpSetts.QRS.max;

    const qtmin = inpSetts.QT.min;
    const qtmax = Q_next_ms !== undefined && Q_next_ms !== null ? Math.min(inpSetts.QT.max, Q_next_ms) : inpSetts.QT.max;

    const anglemin = inpSetts.angles.min;
    const anglemax = inpSetts.angles.max;

    return (
        <div className="ctrl-container ctrl-container-params">
            <div className="ctrl-block">
                <InputGroup
                    {...{ id: "edit.QRS", title: "QRS", val: QRS_ms, units: ms, _key: "QRS_ms", onChanged, min: QRSmin, max: QRSmax }}
                />
                <InputGroup
                    {...{ id: "edit.PQ", title: "PQ", val: PQ_ms, units: ms, _key: "PQ_ms", onChanged, min: PQmin, max: PQmax }}
                    clearable
                />
                <InputGroup
                    {...{ id: "edit.PDur", title: "P↔", val: PDur_ms, units: ms, _key: "PDur_ms", onChanged, min: 0, max: PQmax }}
                    clearable
                />
            </div>
            <div className="ctrl-block">
                <InputGroup
                    {...{ id: "edit.QT", title: "QT", val: QTmax_ms, units: ms, _key: "QTmax_ms", onChanged, min: qtmin, max: qtmax }}
                    clearable
                />
                <QTcAlgtypeEditor
                    {...{
                        QTcAlg,
                        QTcAvailableAlgs,
                        onChanged,
                        loc
                    }}
                />
            </div>
            <div className="ctrl-block">
                <InputGroup
                    {...{
                        id: "edit.angleQRS",
                        title: "∠QRS",
                        val: angle_QRS,
                        units: gr,
                        _key: "angle_QRS",
                        onChanged,
                        min: anglemin,
                        max: anglemax
                    }}
                    clearable
                />
                <InputGroup
                    {...{
                        id: "edit.angleP",
                        title: "∠P",
                        val: angle_P,
                        units: gr,
                        _key: "angle_P",
                        onChanged,
                        min: anglemin,
                        max: anglemax
                    }}
                    clearable
                />
                <InputGroup
                    {...{
                        id: "edit.angleT",
                        title: "∠T",
                        val: angle_T,
                        units: gr,
                        _key: "angle_T",
                        onChanged,
                        min: anglemin,
                        max: anglemax
                    }}
                    clearable
                />
            </div>
        </div>
    );
};

export default withLocalization(CmpxEditor);
